import { paths } from '@farmersdog/constants';

// whyFreshTitle is currently found at website/src/pages/WhyFresh/data
const whyFreshTitle = 'Why Fresh?';

export const leftItems = [
  {
    title: 'Reviews',
    href: paths.PATH_REVIEWS,
  },
  {
    title: 'About Us',
    href: paths.PATH_ABOUT_US,
  },
  {
    title: whyFreshTitle,
    href: paths.PATH_WHY_FRESH,
  },
  {
    title: 'FAQ',
    href: paths.PATH_FAQ,
  },
];

export function useItems() {
  return {
    leftItems,
    persistentItem: {
      title: 'Log In',
      href: paths.PATH_LOGIN,
    },
  };
}
